import React from 'react';
import "./Withdraw_History_list_contant.css";
import Withdraw_History_card from './withdraw_History_card/Withdraw_History_card';

function Withdraw_History_list_contant() {
  const historyData = [
    {
      imgSrc: "/assets/images/services/bank_logo/bank_of_maharashtra.png",
      title: "Withdraw Amount",
      description: "UPI - Axis Bank",
      amount: 399,
      status: "Failed",
      time: "48 minutes ago",
    },
    {
      imgSrc: "/assets/images/services/bank_logo/bank_of_maharashtra.png",
      title: "Withdraw Amount",
      description: "Bank Transfer - SBI",
      amount: 250,
      status: "Success",
      time: "2 hours ago",
    },
    {
      imgSrc: "/assets/images/services/bank_logo/bank_of_maharashtra.png",
      title: "Withdraw Amount",
      description: "Paytm Wallet",
      amount: 150,
      status: "Pending",
      time: "5 hours ago",
    },
    {
      imgSrc: "/assets/images/services/bank_logo/bank_of_maharashtra.png",
      title: "Withdraw Amount",
      description: "Google Pay",
      amount: 499,
      status: "Failed",
      time: "1 day ago",
    },
    {
      imgSrc: "/assets/images/services/bank_logo/bank_of_maharashtra.png",
      title: "Withdraw Amount",
      description: "PhonePe",
      amount: 800,
      status: "Success",
      time: "2 days ago",
    },
  ];

  return (
    <section className='Withdraw_History_list_contant'>
      <div className="row">
        {historyData.map((item, index) => (
          <div className="col-sm-6" key={index}>
            <Withdraw_History_card
              imgSrc={item.imgSrc}
              title={item.title}
              description={item.description}
              amount={item.amount}
              status={item.status}
              time={item.time}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default Withdraw_History_list_contant;
